import React, { useCallback, useEffect, useState } from "react";
import { MdRemoveCircle } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import Loadings from "../../components/Loadings/Loadings";
import { FaEdit } from "react-icons/fa";
import Tooltip from "../../components/Tooltip/Tooltip";
import fetchData from "utils/fetchData";
import stringUtilities from "utils/stringUtilities";
import ReportTemplateControls from "components/ReportTemplateControls";

const PCResults = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState();
  const [questionGroups, setQuestionGroups] = useState();

  const fetchQuestions = async () => {
    try {
      try {
        var pResult = await fetchData.Post('/api/hrmpsb/GetAssessmentResults', {
          JobPositionID: id,
          Name: 'Potential Checklist'
        });
        setResult(pResult);

        var pQuestionGroups = [];
        pResult?.questions?.map(vItem => {
          var pQuestionGroup = pQuestionGroups.find(x => x.id == vItem.groupID);
          if (pQuestionGroup == null) {
            pQuestionGroup = {
              id: vItem.groupID,
              name: vItem.groupName,
              questionsCount: 1
            };
            pQuestionGroups.push(pQuestionGroup);
          } else
            pQuestionGroup.questionsCount++;
        });
        setQuestionGroups(pQuestionGroups);
      } catch (error) {
        console.log('Error in GetBackgroundInventigationeResults: ' + error)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  const ReportTemplateControls_onCreateXml = async () => {
    var pOut = await fetchData.Post("/api/exam/GetBackgroundInventigationeResultsXml", {
      JobPositionID: id,
      QuestionSetName: 'Background Investigation'
    });
    return pOut;
  };

  const ReportTemplateControls_onCreatePdf = async () => {
    var pOut = await fetchData.Post("/api/exam/GetBackgroundInventigationeResultsPdf", {
      JobPositionID: id,
      QuestionSetName: 'Background Investigation'
    });
    return pOut;
  };

  return (
    <>
      {isLoading ? (
        <Loadings />
      ) : (
        <div className="">
          <div className="flex items-center justify-between">
            <div class="inline-flex rounded-md shadow-sm" role="group">
              <a
                href={`/#/technical-competencies-results/${id}`}
                type="button"
                className="inline-flex items-center px-4 py-2 text-sm font-medium border-r text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
                disabled
              >
                Technical Competencies
              </a>

              <a href={`/#/work-attributes-results/${id}`}
                className="inline-flex items-center px-4 py-2 text-sm font-medium border-r text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
              >
                Work Attributes
              </a>

              <a href={`/#/pcpt-results/${id}`}
                className="inline-flex items-center px-4 py-2 text-sm font-medium border-r text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
              >
                PCPT
              </a>

              <a href={`/#/potential-checklist-results/${id}`}
                className="inline-flex items-center px-4 py-2 text-sm font-medium border border-gray-200 focus:z-10 focus:ring-2 bg-primary  text-white focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
              >
                Potential Checklist
              </a>
              <a
                href={`/#/consolidated-results/${id}/2`}
                className="inline-flex items-center px-4 py-2 text-sm font-medium border-r text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
              >
                Consolidated
              </a>
            </div>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Job Position: {result?.jobPosition?.name}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Date Posted: {stringUtilities.FormatDate(result?.jobPosition?.postingDate)}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Applicant Deadline: {stringUtilities.FormatDate(result?.jobPosition?.applicationDeadline)}
            </h1>
          </div>
          <div className="flex justify-end mr-2">
            <ReportTemplateControls
              repxName="BIResult"
              onCreateXml={ReportTemplateControls_onCreateXml}
              onCreatePdf={ReportTemplateControls_onCreatePdf}
            />
          </div>
          <table className="mt-4 border w-full max-h-[65vh]">
            <tr className="bg-primary">
              <th rowSpan="2" className="text-center text-white p-2 border">
                No.
              </th>
              <th rowSpan="2" className="text-center text-white p-2 border">
                Name of Applicant
              </th>
              {result?.questions?.map(pQuestion => {
                return <th className="text-center text-white p-2 border">
                  {pQuestion.criterion}
                </th>
              })}
              <th rowSpan="2" className="text-center text-white p-2 border">
                Total
              </th>
            </tr>

            <tr className="bg-primary">
              {result?.questions?.map(pQuestion => {
                return <th className="text-center text-white p-2 border">
                  {pQuestion.score} POINTS
                </th>
              })}
            </tr>

            {result?.applicants?.length > 0 ?
              result?.applicants?.map((vApplicant, vIndex) => {
                return <tr>
                  <td className="p-2 border text-center">
                    {vIndex + 1}
                  </td>
                  <td className="p-2 border text-primary">
                    <a className="" href={'/#/background-investigation-result-details/' + id + '/' + vApplicant.applicantID}>{vApplicant.applicantName || ''}</a>
                  </td>

                  {result?.questions?.map(vQuestion => {
                    return <td className="p-2 border text-center">
                      {vApplicant.criteria[vQuestion.criterion]}
                    </td>
                  }) /* results?.questions?.map */}
                  <td className="p-2 border text-center">
                    {vApplicant.total}
                  </td>
                </tr>
              }) /* result?.applicants?.map */
              : 
              <tr>
                <td colSpan={3 + result?.questions?.length} className="text-center p-4">
                No records found
                </td>
              </tr>
            }
          </table>
        </div>
      )}
    </>
  );
};

export default PCResults;
